import i18n from '../i18n'
import { ETicketPriorites, ETicketStatuses } from './types';

export const MAXIMUM_CHARACTERS_DESCRIPTION = 250;
export const MINIMUM_CHARACTERS_DESCRIPTION = 30;
export const MAXIMUM_CHARACTERS_KEYWORDS = 50;
export const MINIMUM_CHARACTERS_KEYWORDS = 7;

export const SUBSCRIPTIONS = 'subscriptions';
export const CREDITS = 'credits';
export const FAST_DOWNLOAD = 'fast-download';

export const BASE_URL = `${process.env.REACT_APP_PUBLIC_URL}/`;
// export const BASE_URL = 'http://localhost:3000/';
export const SELLER = 'seller';
export const BUYER = 'buyer';
export const VALID = 'valid';
export const NOT_CHECKED = 'not_checked';
export const FILESIZEPNG = 0;
export const FILESIZEEPS = 0;
export const FILESIZEJPG = 0;

export const DECLINED = 'declined'

export const WAITING = 'waiting';
export const CONFIRMED = 'confirmed';
export const APPROVED = 'approved';
export const PAID = 'paid';
export const DENIED = 'denied';
export const PENDING = 'pending';
export const REFUNDED = 'refunded';

export const KEYWORDS_PNG = ['transparent', 'transparent background', 'png', 'transparent png'];
export const KEYWORDS_EPS = ['transparent', 'transparent background', 'eps', 'transparent eps'];
export const KEYWORDS_EPS_PNG = ['transparent', 'transparent background', 'eps', 'transparent eps', 'png', 'transparent png'];

export const KEYWORDS_IS_ADULT = ['adult'];
export const KEYWORDS_IS_AI = ['ai'];
export const KEYWORDS_IS_EDITORIAL = ['editorial'];

export const PROPERTY_RELEASE_TYPE = 'property';
export const MODEL_RELEASE_TYPE = 'model';
export const MINOR_RELEASE_TYPE = 'minor';

export const STRIPE_PAYMENT_TYPE = 'stripe';

export const ROUTES = {
  UNFINISHED: 'unfinished',
  UPLOAD: 'upload',
  PUBLICATIONS: 'publications',
  EXAMINATION: 'examination',
  ACCOUNT: 'account',
  SETTINGS: 'settings',
  LICENSING: 'licensing',
  DECLINED: 'declined',
  RELEASES: 'releases',
  EARNINGS:'earnings',
  STATISTICS: 'statistics',
  MYPAYMENT:'myPayment',
  HISTORY: 'history',
  TAXCENTER:'tax-center',
  LIGHTBOX: 'lightBox',
  DOWNLOADS: 'downloads',
  PAYMENT: 'payment',
  SUBSCRIPTIONS: 'subscriptions',
  CREDITS: 'credits',
  INVOICES: 'invoices',
  NOTIFICATIONS: 'notifications',
  CONFIRM_PAYOUT: 'confirm-payment-payout/:token',
  PLAN_PRICES: 'plans-prices',
  ASSETS: 'assets',
  LOGIN: 'login',
  REGISTER: 'register',
  SUPPORT: 'support'
}

export interface IFilters {
  category?: 'JPG' | 'PNG' | 'EPS'
  searchFilter?: string
  sortByFilter?: string
  typeFilter?: string[]
  advancedSearch?: {
    itemId?: string
    author?: string
    date?: Date
  }
  orientation?: string
  items?: number
  ai_network?: string
  model?: string
  minor?: string
}
export const initialFiltersConst = {
  orientation: 'all',
  items: 100,
}
interface TextAndImageMap {
  [key: number]: {
    title: string
    description: string
    image: NodeRequire
  }
}

interface IPlanAndPricesOption {
  description: number
  price: number
}

export interface ISubscriptionsCreditsProps {
  name?: string
  id?: string
  recommendedText: string
  covers: string[]
  options?: IPlanAndPricesOption[]
  category: 'Credits' | 'Subscriptions'
  isCenter?: boolean
  plans?: any
  price?: number,
  qty?: number,
  description?: string,
  type?: string,
  is_subscription: boolean;
}

interface IPlansAndPricesProps {
  Subscriptions:  ISubscriptionsCreditsProps[],
  Credits: ISubscriptionsCreditsProps[],
  others: ISubscriptionsCreditsProps[]
}

export const constants = {
  logo_layerstock: require('../images/logo-layerstock.png'),
  crop_png: require('../images/png-crop.jpg'),
  crop_jpg: require('../images/jpg-crop.jpg'),
  crop_eps: require('../images/eps-crop.jpg'),
  lightbox: require('../images/lightbox.jpg'),
  img_background1: require('../images/bg1.jpg'),
  img_background2: require('../images/bg2.jpg'),
  img_background3: require('../images/bg3.jpg'),
  img_jpg: require('../images/jpg.png'),
  img_png: require('../images/png.png'),
  img_eps: require('../images/eps.png'),
  img_wide: require('../images/default_banner.jpg'),
  img_avatar: require('../images/default_avatar.jpg'),
  img_new: require('../images/cat.jpg')
}

export const textAndImage: TextAndImageMap = {
  0: {
    title: i18n.t('Title_PNG'),
    description: i18n.t('Description_PNG'),
    image: constants.img_png,
  },
  1: {
    title: i18n.t('Title_EPS'),
    description: i18n.t('Description_EPS'),
    image: constants.img_eps,
  },
  2: {
    title: i18n.t('Title_JPG'),
    description: i18n.t('Description_JPG'),
    image: constants.img_jpg,
  },
}

export enum NavigationEnum {
  HOME = '/',
  ASSETS = '/assets',
  ASSET_DETAILS = '/assets/:assetName',
  ASSET_DETAILS_BUY = '/assets/:assetName/buy',
  ABOUT = '/about',
  PLANS_PRICES = '/plans-prices',
  LOGIN = '/login',
  REGISTER = '/register',
  CONFIRM_ACCOUNT = '/confirm-account',
  FORGOT_PASSWORD = '/forgot-password',
  ACCOUNT = '/account',
  USERS = '/users',
  NOWHERE = '',
  RESETPASSWORD = '/reset-password/:token',
  FAQ = '/faq',
  TERMS_AND_CONDITIONS = '/terms-and-conditions',
  PRIVACY_POLICY = '/privacy-policy'
}

export const navItems = [
  { title: i18n.t('Home'), value: 1, to: NavigationEnum.HOME },
  {
    title: i18n.t('Stock'),
    // listOfItems: [
    //   { name: i18n.t('Images'), value: 21, to: NavigationEnum.ASSETS },
    //   { name: i18n.t('Lightboxes'), value: 22, to: `${ROUTES.ACCOUNT}/${ROUTES.LIGHTBOX}` },
    // ],
    value: 2,
    to: NavigationEnum.ASSETS,
  },
  {
    title: i18n.t('Categories'),
    listOfItems: [
      { name: i18n.t('EPS'), value: 31, to: NavigationEnum.ASSETS, params: 'eps' },
      { name: i18n.t('JPG'), value: 32, to: NavigationEnum.ASSETS, params: 'jpg' },
      { name: i18n.t('PNG'), value: 33, to: NavigationEnum.ASSETS, params: 'png' },
    ],
    value: 3,
    to: NavigationEnum.NOWHERE,
  },
  // {
  //   title: i18n.t('Site info'),
  //   listOfItems: [
  //     { name: i18n.t('About'), value: 41, to: NavigationEnum.ABOUT },
  //     { name: i18n.t('FAQ'), value: 42, to: NavigationEnum.FAQ },
  //   ],
  //   value: 4,
  //   to: NavigationEnum.NOWHERE,
  // },
]

export const examinationStatuses = ['pending', 'approved', 'declined'];
export const examinationStatusPendingIndex = 0;
export const examinationStatusApprovedndex = 1;
export const examinationStatusDeclinedIndex = 2;

export const ticketStatuses: (keyof typeof ETicketStatuses)[] = ['open', 'in_progress', 'closed', 'resolved'];
export const ticketPriorities: (keyof typeof ETicketPriorites)[] = ['low', 'medium', 'high'];

const buyerSupportCategoryTypes = [
  {
    group: 'account_registration',
    priority: ticketPriorities[ETicketPriorites.low],
    items: [
      { id: 'password-reset', name: 'password_reset' },
      { id: 'profile-management', name: 'profile_management' },
      { id: 'account-transfer', name: 'account_transfer_request' },
      { id: 'account-deactivation', name: 'account_deactivation_request' },
    ]
  },
  // Buyer Support Group
  {
    group: 'buyer_support',
    items: [
      { id: 'subscription-questions', name: 'subscription_questions' },
      { id: 'credit-purchases', name: 'credit_purchases' },
      { id: 'download-issues', name: 'download_issues' },
      { id: 'license-inquiries', name: 'license_inquiries' },
      { id: 'payment-problems', name: 'payment_problems' },
      { id: 'refund-requests', name: 'refund_requests' },
      { id: 'invoice-requests', name: 'invoice_requests' }
    ]
  },
  {
    group: 'technical_issues',
    priority: ticketPriorities[ETicketPriorites.low],
    items: [
      { id: 'website-functionality', name: 'website_functionality' },
      { id: 'search-issues', name: 'search_issues' },
      { id: 'browser-compatibility', name: 'browser_compatibility' },
      // { id: 'mobile-support', name: 'mobile_app_support' }
    ]
  },
  
  // Licensing & Legal Group
  {
    group: 'licensing_legal',
    priority: ticketPriorities[ETicketPriorites.high],
    items: [
      { id: 'license-usage', name: 'license_usage_questions' },
      { id: 'copyright-concerns', name: 'copyright_concerns' },
      { id: 'editorial-commercial', name: 'editorial_vs_commercial_use' },
      { id: 'extended-license', name: 'extended_license_requests' },
      { id: 'terms-clarification', name: 'terms_service_clarification' }
    ]
  },
  {
    group: 'billing_financial',
    priority: ticketPriorities[ETicketPriorites.high],
    items: [
      { id: 'payment-methods', name: 'payment_method_issues' }, // buyer
      { id: 'subscription-management', name: 'subscription_management' }, // buyer
      { id: 'credit-card-problems', name: 'credit_card_problems' } // buyer
    ]
  },
  {
    group: 'general_inquiries',
    priority: ticketPriorities[ETicketPriorites.medium],
    items: [
      { id: 'platform-info', name: 'platform_information' },
      { id: 'partnerships', name: 'partnership_opportunities' },
      { id: 'bulk-licensing', name: 'bulk_licensing' },
      { id: 'custom-requests', name: 'custom_requests' },
      { id: 'feature-suggestions', name: 'feature_suggestions' },
      { id: 'feedback-complaints', name: 'feedback_and_complaints' }
    ]
  },
  {
    group: 'other',
    priority: ticketPriorities[ETicketPriorites.low],
    items: [
      { id: 'other', name: 'other_inquiry' }
    ]
  }
];

const sellerSupportCategoryTypes = [
  // Account & Registration Group
  {
    group: 'account_registration',
    priority: ticketPriorities[ETicketPriorites.low],
    items: [
      { id: 'password-reset', name: 'password_reset' },
      { id: 'profile-management', name: 'profile_management' },
      { id: 'account-transfer', name: 'account_transfer_request' },
      { id: 'account-deactivation', name: 'account_deactivation_request' },
    ]
  },
  
  // Contributor Support Group
  {
    group: 'contributor_support',
    priority: ticketPriorities[ETicketPriorites.medium],
    items: [
      { id: 'account-verification', name: 'account_verification' },
      { id: 'image-submission', name: 'image_submission_process' },
      { id: 'upload-problems', name: 'upload_problems' },
      { id: 'licensing-requirements', name: 'licensing_requirements' },
      { id: 'model-releases', name: 'model_property_releases' },
      { id: 'rejection-reasons', name: 'image_rejection_reasons' },
      { id: 'earnings-royalties', name: 'earnings_and_royalties' },
      { id: 'payment-requests', name: 'payment_requests' },
      { id: 'tax-forms', name: 'tax_form_assistance' },
    ]
  },
  
  // Technical Issues Group
  {
    group: 'technical_issues',
    priority: ticketPriorities[ETicketPriorites.low],
    items: [
      { id: 'website-functionality', name: 'website_functionality' },
      { id: 'search-issues', name: 'search_issues' },
      { id: 'browser-compatibility', name: 'browser_compatibility' },
      // { id: 'mobile-support', name: 'mobile_app_support' }
    ]
  },
  
  // Licensing & Legal Group
  {
    group: 'licensing_legal',
    priority: ticketPriorities[ETicketPriorites.high],
    items: [
      { id: 'license-usage', name: 'license_usage_questions' },
      { id: 'copyright-concerns', name: 'copyright_concerns' },
      { id: 'editorial-commercial', name: 'editorial_vs_commercial_use' },
      { id: 'extended-license', name: 'extended_license_requests' },
      { id: 'terms-clarification', name: 'terms_service_clarification' }
    ]
  },
  
  // Image Quality & Content Group
  {
    group: 'image_quality_content', // contributor
    priority: ticketPriorities[ETicketPriorites.medium],
    items: [
      { id: 'technical-requirements', name: 'technical_requirements' },
      { id: 'image-formatting', name: 'image_formatting' },
      { id: 'keyword-optimization', name: 'keyword_optimization' },
      { id: 'content-guidelines', name: 'content_guidelines' },
      { id: 'editorial-requirements', name: 'editorial_category_requirements' },
      { id: 'ai-content-policies', name: 'ai_generated_content_policies' }
    ]
  },
  
  // Billing & Financial Group
  {
    group: 'billing_financial',
    priority: ticketPriorities[ETicketPriorites.high],
    items: [
      { id: 'tax-withholding', name: 'tax_withholding_questions' }, // seller
      { id: 'revenue-reporting', name: 'revenue_reporting' }, // seller
      { id: 'financial-docs', name: 'financial_documentation' } // seller
    ]
  },
  
  // General Inquiries Group
  {
    group: 'general_inquiries',
    priority: ticketPriorities[ETicketPriorites.medium],
    items: [
      { id: 'platform-info', name: 'platform_information' },
      { id: 'partnerships', name: 'partnership_opportunities' },
      { id: 'bulk-licensing', name: 'bulk_licensing' },
      { id: 'custom-requests', name: 'custom_requests' },
      { id: 'feature-suggestions', name: 'feature_suggestions' },
      { id: 'feedback-complaints', name: 'feedback_and_complaints' }
    ]
  },
  
  // Other Group
  {
    group: 'other',
    priority: ticketPriorities[ETicketPriorites.low],
    items: [
      { id: 'other', name: 'other_inquiry' }
    ]
  }
];

export const supportCategoryTypes = (userRole: string) => {
  if (userRole === SELLER) {
    return sellerSupportCategoryTypes;
  }
  if (userRole === BUYER) {
    return buyerSupportCategoryTypes;
  }
  return [];
};